import { useState, useMemo, useEffect, useRef } from 'react';
import throttle from 'lodash.throttle';

export const useScrollDown = () => {
  const lastScrollTop = useRef(0);
  const [positionTop, setPositionTop] = useState(true);
  const [scrollDown, setScrollDown] = useState(false);

  const handleScroll = () => {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    if (st === 0) {
      setPositionTop(true);
    } else {
      setPositionTop(false);
    }
    if (st - lastScrollTop.current > 0.3) {
      // modify this line for scroll threshold
      setScrollDown(true);
    } else if (st - lastScrollTop.current < -0.3) {
      // modify this line for scroll threshold
      setScrollDown(false);
    }
    lastScrollTop.current = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  };

  const throttledHandler = useMemo(() => throttle(handleScroll, 100), []);

  useEffect(() => {
    window.addEventListener('scroll', throttledHandler, { passive: true });
    return () => window.removeEventListener('scroll', throttledHandler);
  }, []);

  return { positionTop, scrollDown };
};

export default useScrollDown;
